var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.question.options),function(option,k){return _c('v-checkbox',{key:("select-" + k),attrs:{"label":option.text,"value":((option.id) + "~" + (option.value)),"multiple":true},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}),1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1833691a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/surveys/run/answer-multiple.vue
// module id = VaGP
// module chunks = 2